// SelectedTabIndicator.tsx
import { AnimatePresence, motion } from 'framer-motion';
import { cn } from '@/utils/tailwind';

interface IndicatorStyle {
  left: number;
  width: number;
  bottom: number;
}

interface SelectedTabIndicatorProps {
  indicator: IndicatorStyle | null;
}

export const SelectedTabIndicator = ({ indicator }: SelectedTabIndicatorProps) => {
  return (
    <AnimatePresence>
      {indicator && (
        <motion.span
          key="tab-indicator"
          className={cn('absolute z-0 h-[2px] bg-gr-300')} // 높이 2px, 검은색
          style={{
            left: indicator.left,
            width: indicator.width,
            bottom: indicator.bottom,
          }}
          initial={{ opacity: 0 }}
          animate={{
            opacity: 1,
            left: indicator.left,
            width: indicator.width,
          }}
          exit={{ opacity: 0 }}
          transition={{ type: 'spring', stiffness: 400, damping: 30 }}
        />
      )}
    </AnimatePresence>
  );
};
